class Router{

    constructor(){
        
        this.routerClass = null;
        this.router = null;

    }

    static getInstance(){
        if(this.routerClass==null){
            this.routerClass = new Router();
        }
        return this.routerClass;
    }

    setRouter(router){
        this.router = router;
    }

    getRouter(){
        return this.router;
    }

    goGameEnd(){
        this.router.push('/game/gameEnd');
    }

    goGameIndex(){
        let gameEntrance = localStorage.getItem('gameEntrance') || '/train/index'
        this.router.push(gameEntrance);
    }

}

export default Router;